import { Component, EventEmitter, Input, Output } from "@angular/core";
import { COLORS } from "../models";

type chipSize = "small" | "medium" | "large";

@Component({
    selector: "mobi-office-lib-chips",
    templateUrl: "./chips.component.html",
    styleUrls: ["./chips.component.scss"],
    standalone: false
})
export class ChipsComponent {
  @Input({ required: true }) chipText: string = "";
  @Input() chipValue: number | string = 0 || "";
  @Input() idDisabled: boolean = false;
  @Input() isDeletable: boolean = false;
  @Input() chipSize: chipSize = "medium";
  @Input() chipColor: COLORS = "primary";
  @Input() isBordered: boolean = false;
  @Input() chipClass: string = "";

  // ICON
  @Input() iconPath: string = "";
  @Input() iconAltText: string = "chip-icon";
  @Input() iconClass: string = "";

  // Delete
  @Input() deleteIconPath: string = "global-assets/mobi-office-ui/close.svg";
  @Input() deleteIconAltText: string = "delete-icon";
  @Input() deleteIconClass: string = "";

  @Output() iconEmitter = new EventEmitter();
  @Output() deleteEmitter = new EventEmitter();

  onIcon($event: any) {
    this.iconEmitter.emit({
      chipText: this.chipText,
      chipValue: this.chipValue,
    });
  }

  onDelete(event: any) {
    this.deleteEmitter.emit({
      chip: event,
      chipText: this.chipText,
      chipValue: this.chipValue,
    });
  }
}
